import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from '@shopify/polaris';
import { ChatIcon } from '@shopify/polaris-icons';

import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

const ProjectCommunicationsSidebar = () => {
  const location = useLocation();
  const { user } = useContext(AuthenticationContext);

  const isAdminUser = user?.modules?.some(
    (module) => module.value === 'project_communication' && parseInt(module.tier) > 2,
  );

  const subNavigationItems = [
    {
      url: '/project_communications/search',
      disabled: false,
      label: 'All Communications',
    },
  ];

  if (isAdminUser) {
    subNavigationItems.push(
      {
        url: '/project_communications/job_execution_statuses',
        disabled: false,
        label: 'Job Execution Statuses',
      },
      {
        url: '/project_communications/servman_sql_logs',
        disabled: false,
        label: 'Servman Logs',
      },
    );
  }

  const navigationItems = [
    {
      label: 'Project Communications',
      url: '/project_communications/search',
      icon: ChatIcon as any,
      matches: true,
      subNavigationItems,
    },
  ];

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section items={navigationItems} />
    </Navigation>
  );
};

export default ProjectCommunicationsSidebar;
